// reducers
function roadblock(state = {}, action) {
  switch (action.type) {
    case 'ROADBLOCK':
      return action.payload;

    default:
      return state;
  }
}

export default roadblock;
